import { useCallback, useEffect, useRef, useState } from "react";
import supabase from "../supabaseClient";
import { useAppIssueContext } from "../context/appIssueContext";

export default function MessageForm(props) {
  const { username, country, session } = useAppIssueContext();

  const [message, setMessage] = useState("");

  const [isSending, setIsSending] = useState(false);

  const editor = useRef({ content: {} });

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setIsSending(true);
      if (!message) return;

      setMessage("");

      try {
        const { error } = await supabase.from("messages").insert([
          {
            text: message,
            username,
            country,
            is_authenticated: session ? true : false,
            fk_message_issue: props.issue_id,
          },
        ]);

        // if (error) {
        //   console.error(error.message);
        //   toast({
        //     title: "Error sending",
        //     description: error.message,
        //     status: "error",
        //     duration: 9000,
        //     isClosable: true,
        //   });
        //   return;
        // }
        console.log("Sucsessfully sent!");
        if (editor.current) {
          editor.current.content.innerHTML = "";
        }
      } catch (error) {
        console.log("error sending message:", error);
      } finally {
        setIsSending(false);
      }
    },
    [message, editor.current],
  );

  useEffect(() => {
    // Initialize pell on an HTMLElement
    editor.current = window.pell.init({
      element: document.getElementById(`editor_${props.issue_id}`),

      // <Function>, required
      // Use the output html, triggered by element's `oninput` event
      onChange: (html) => {
        console.log(html);
        setMessage(html);
      },

      // <string>, optional, default = 'div'
      // Instructs the editor which element to inject via the return key
      defaultParagraphSeparator: "div",

      // <boolean>, optional, default = false
      // Outputs <span style="font-weight: bold;"></span> instead of <b></b>
      styleWithCSS: false,

      actions: [
        "bold",
        "underline",
        "strikethrough",
        "italic",
        "heading1",
        "heading2",
        "olist",
        "ulist",
        "code",
        "paragraph",
        "line",
      ],
    });
  }, [props.issue_id]);

  return (
    <div>
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="d-flex flex-column">
          <div>
            <div id={`editor_${props.issue_id}`} className="pell"></div>
          </div>
          <button className="btn btn-primary mt-2 align-self-end" type="submit" disabled={!message}>
            Envoyer
          </button>
        </div>
      </form>
    </div>
  );
}
